module.exports = __webpack_public_path__ + "img/30.5d3367c1.jpg";